import validate from "/codebuild/output/src3418197868/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/codebuild/output/src3418197868/src/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/codebuild/output/src3418197868/src/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/auth.mjs")
}